export default __webpack_public_path__ + "static/media/ads.0c8bd3dd.svg";